import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Seatingplan } from '../models';
import { UnsafeAction } from "./UnsafeAction"

/* tslint:disable */
@Injectable()
export class SeatingplanServerActions {


	static SEATINGPLAN_LOADED = "[SeatingplanServer] Seatingplan loaded";
	seatingplanLoaded(seatingplan: Seatingplan): UnsafeAction {
		return {
			type: SeatingplanServerActions.SEATINGPLAN_LOADED,
			payload: seatingplan
		}
	}


}



// WEBPACK FOOTER //
// ./src/app/actions/seatingplan-server.actions.ts